import axios, { getAuthHeaders } from './config'
export default {

    all: function() {
        return axios.get('/actionTypes', {
            headers: getAuthHeaders()
        })
    },
}